import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { MerchantNotification } from "@shared/schema";

export function useMerchantNotifications(options?: { enabled?: boolean }) {
  return useQuery<MerchantNotification[]>({
    queryKey: ["/api/merchant/notifications"],
    enabled: options?.enabled ?? true,
    refetchInterval: 30000,
  });
}

export function useMerchantUnreadCount(options?: { enabled?: boolean }) {
  return useQuery<{ count: number }>({
    queryKey: ["/api/merchant/notifications/unread-count"],
    enabled: options?.enabled ?? true,
    refetchInterval: 15000,
  });
}

export function useMarkNotificationRead() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async (notificationId: number) => {
      const res = await fetch(`/api/merchant/notifications/${notificationId}/read`, {
        method: "PATCH",
        credentials: "include",
      });
      if (!res.ok) throw new Error("Failed to mark notification as read");
      return res.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["/api/merchant/notifications"] });
      queryClient.invalidateQueries({ queryKey: ["/api/merchant/notifications/unread-count"] });
    },
  });
}

export function useMarkAllNotificationsRead() {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async () => {
      const res = await fetch("/api/merchant/notifications/mark-all-read", {
        method: "PATCH",
        credentials: "include",
      });
      if (!res.ok) throw new Error("Failed to mark all notifications as read");
      return res.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["/api/merchant/notifications"] });
      queryClient.invalidateQueries({ queryKey: ["/api/merchant/notifications/unread-count"] });
    },
  });
}
